import Vue from "vue";
import {IVOptionSetLocal} from "~/interfaces/vSelectInterfaces";
import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import ObjectModel from "~/models/objectModel";
import PropertySection from "~/models/objectModels/propertySection";
import {EnumHelper} from "~/helpers/enumHelper";
import {
  ObjectModelBuiltinPropertyType,
  ObjectModelBuiltinPropertyTypeName
} from "~/enums/objectModelBuiltinPropertyType";

type TFilter = null | Array<ObjectModelPropertyRootType> | ((ObjectModelProperty) => boolean);

function filterToFunc(filter: TFilter): (ObjectModelProperty) => boolean {
  if (filter === null) {
    return () => true;
  } else if (Array.isArray(filter)) {
    return (prop) => filter.includes(prop.property_type);
  } else {
    return filter;
  }
}

export default Vue.extend({
  methods: {
    propertySelectOptionSets(objectModel: ObjectModel, allowBuiltin: boolean, filter: TFilter = null, valueKey: string = 'id'): IVOptionSetLocal[] {
      const optionSets: IVOptionSetLocal[] = [];

      const groupedProperties = objectModel.propertiesGroupedBySection;
      if (filter) {
        const func = filterToFunc(filter);
        Object.entries(groupedProperties).forEach(([k, v]: [string, ObjectModelProperty[]]) => {
          groupedProperties[k] = v.filter(func);
        });
      }
      const propertiesAndSections: Array<ObjectModelProperty | PropertySection> =
        [...groupedProperties.no_section, ...objectModel.propertySectionsArray]
          .sort((a, b) => a.sort_order - b.sort_order);

      if (allowBuiltin) {
        optionSets.push({
          labelKey: 'label',
          valueKey: 'type',
          heading: 'About Record',
          options: EnumHelper.toArray(ObjectModelBuiltinPropertyType).map(type => {
            return {type, label: ObjectModelBuiltinPropertyTypeName[type]};
          }),
          optionType: 'builtin',
        });
      }

      let lastSetWasUngroupedProperties = false;

      for (const propOrSection of propertiesAndSections) {
        if (propOrSection instanceof ObjectModelProperty) {

          if (lastSetWasUngroupedProperties) {
            optionSets[optionSets.length - 1].options.push(propOrSection);
          } else {
            const set: IVOptionSetLocal = {
              labelKey: 'labelTitleDisplay',
              valueKey,
              optionType: 'property',
              options: [propOrSection],
            };
            optionSets.push(set);
            lastSetWasUngroupedProperties = true;
          }

        } else {

          lastSetWasUngroupedProperties = false;

          if (!groupedProperties[propOrSection.client_id]?.length) {
            continue;
          }

          const set: IVOptionSetLocal = {
            labelKey: 'labelTitleDisplay',
            valueKey,
            optionType: 'property',
            options: groupedProperties[propOrSection.client_id],
            heading: propOrSection.labelTitleDisplay,
          };
          optionSets.push(set);

        }
      }

      return optionSets;
    },
  },
});